import { render } from "./ImprestHistory.vue?vue&type=template&id=1df96310&scoped=true"
import script from "./ImprestHistory.vue?vue&type=script&lang=js"
export * from "./ImprestHistory.vue?vue&type=script&lang=js"

import "./ImprestHistory.vue?vue&type=style&index=0&id=1df96310&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1df96310"]])

export default __exports__